export class TextChangedEvent {
    oldText: string;
    newText: string;

    constructor(oldText: string, newText: string) {
        this.oldText = oldText;
        this.newText = newText;
    }
}
